import { gql, useMutation } from "@apollo/client";
import type { IdeaBookItem } from "./types";

const ADD_IDEA_BOOK_ITEM = gql`
  mutation AddIdeaBookItem(
    $ideaBookId: ID!
    $homeownerId: ID!
    $imageId: ID!
    $note: String
  ) {
    addIdeaBookItem(
      ideaBookId: $ideaBookId
      homeownerId: $homeownerId
      imageId: $imageId
      note: $note
    ) {
      _id
      ideaBookId
      homeownerId
      note
      createdAt
      updatedAt
      image {
        _id
        url
        path
        title
        description
        credit
      }
    }
  }
`;

type AddIdeaBookItemData = {
  addIdeaBookItem: IdeaBookItem;
};

type AddIdeaBookItemVars = {
  ideaBookId: string;
  homeownerId: string;
  imageId: string;
  note?: string | null;
};

export const useAddIdeaBookItem = () => {
  const [addIdeaBookItemMutation, { loading, error, data }] = useMutation<
    AddIdeaBookItemData,
    AddIdeaBookItemVars
  >(ADD_IDEA_BOOK_ITEM);

  const addIdeaBookItem = async (args: AddIdeaBookItemVars) => {
    const result = await addIdeaBookItemMutation({ variables: args });
    return result.data?.addIdeaBookItem ?? null;
  };

  return { addIdeaBookItem, loading, error, data };
};
